import WorthyApi from 'lib/api/worthyApi';
import rootStore from 'reducers';
import { ado } from 'actions/ado';
import { session } from 'actions/session';
import { showLoader, hideLoader } from 'actions/loader';
import GA from 'lib/ga';
import Intercom from "lib/intercom";

export const PERFORM_REGISTER = Symbol('PERFORM_REGISTER');

export function beforeRegistration(promise){
    rootStore.dispatch(showLoader());
    rootStore.dispatch(performRegisterRedux(promise))
}

export function afterSuccessfulRegistration(params, response){
    const data = response.data
        const user = data.user
        rootStore.dispatch(session(user));
        GA.funnelStage(0);
        let label = 'Else';
        if (params.bundleType === 'jewelryBox'){
            label ='Jewelry box';
            if(user && user.jb_events_data && user.is_new_user) {
                const jb_estimation = user.jb_events_data.jb_estimation
                const jb_score = user.jb_events_data.jb_score
                const factor = user.jb_events_data.fb_ml1_exp_factor
                const value = jb_estimation * jb_score * factor
            }
        }else if(params.bundleType === 'standard'){
            label = params.itemType;
        }
        user.intercomDataEvent && Intercom.updateContactData(JSON.parse(user.intercomDataEvent))
        GA.registerFormSuccessfully();
        rootStore.dispatch(hideLoader());
        let adoTimeout = params.bundleType === 'jewelryBox' ? 7000 : 2000;
        rootStore.dispatch(ado());
        setTimeout(()=>{
            rootStore.dispatch(ado());
        }, adoTimeout);
        return response;
}

export function afterFailedRegistration(error){
    rootStore.dispatch(session(null));
        rootStore.dispatch(hideLoader());
        throw error;
}

export function performRegisterationWithFunction(params, registrationFunction) {
    let request = registrationFunction().then((response)=>{
        return afterSuccessfulRegistration(params, response)
    }).catch((error)=>{
        afterFailedRegistration(error)
    });
    beforeRegistration(request)
    

    return {
        type:       PERFORM_REGISTER,
        payload:    request
    }
}

export function performRegister(params){
    return performRegisterationWithFunction(params, ()=> WorthyApi.register(params))
}

export function performRegisterWithGoogle(params){

}

function performRegisterRedux(request) {
    return {
        type:       PERFORM_REGISTER,
        payload:    request
    }
}